import { COPY_URL_LINK, EMBED, SHARE } from 'Angular/constants/core.constants';
import { NO_COMPARABLE } from 'HypotheticalsApp/apps/hypotheticals-app/constants';
export const HYPOTHETICALS_STATE_KEYS = [
    'hypotheticalId',
    'securityId',
    'startDate',
    'endDate',
    'initialInvestment',
    'comparableId',
    'comparableType',
    'rateOfReturn',
    'rateOfReturnType',
    'scenarios',
    'contributionTimeframe',
    'contributionTableTimeframe',
    'showComparison',
    'showNetContributions',
    'showStandardDeviation',
    'showBaseCase',
    'prompt',
];
export const SAVED_HYPOTHETICAL_STATE_KEYS = [
    'securityId',
    'startDate',
    'endDate',
    'initialInvestment',
    'comparableId',
    'comparableType',
    'rateOfReturn',
    'rateOfReturnType',
    'scenarios',
    'contributionTimeframe',
    'contributionTableTimeframe',
    'showComparison',
    'showNetContributions',
    'showStandardDeviation',
    'showBaseCase',
];
export const HYPOTHETICALS_PDF_EXPORT_KEYS = HYPOTHETICALS_STATE_KEYS.concat(['reportTitle']);
export const HYPOTHETICALS_SCENARIO_CHART_EMBED_KEYS = HYPOTHETICALS_STATE_KEYS.concat([
    'securityId',
    'hypotheticalId',
    'mode',
    'partner',
    'redesign',
]);
export const HYPOTHETICALS_APP_STATE_SLICE_KEY = 'hypotheticals';
export const HYPOTHETICALS_SYSTEM_DEFAULT_STATE = {
    hypotheticalId: null,
    securityId: null,
    startDate: '',
    endDate: '',
    initialInvestment: null,
    comparableId: null,
    comparableType: NO_COMPARABLE,
    rateOfReturn: null,
    rateOfReturnType: null,
    scenarios: [],
    isScenarioSubmitted: false,
    contributionTimeframe: 'monthly',
    contributionTableTimeframe: 'monthly',
    showComparison: true,
    showNetContributions: true,
    showStandardDeviation: true,
    showBaseCase: false,
    prompt: null,
    useClientGroupConfig: false,
};
export const SAVED_HYPOTHETICAL_SHARING_OPTIONS = {
    title: {
        label: 'Share',
        icon: 'icon-share',
    },
    list: [
        {
            type: 'option',
            label: 'Share with Team',
            value: SHARE,
            icon: 'icon-team',
        },
        {
            type: 'option',
            label: 'Embed Code',
            value: EMBED,
            icon: 'icon-embed',
        },
        {
            type: 'option',
            label: 'Copy Link',
            value: COPY_URL_LINK,
            icon: 'icon-link',
        },
    ],
};
export const ANALYSIS_PLAN_STATE_KEYS = [
    'analysisPlanId',
    'clientName',
    'clientLastname',
    'objective',
    'securityId',
    'startDate',
    'endDate',
    'initialInvestment',
    'targetInvestment',
    'comparableId',
    'comparableType',
    'comparableSecurityType',
    'rateOfReturn',
    'rateOfReturnType',
    'scenarios',
    'contributionTimeframe',
    'contributionTableTimeframe',
    'showBaseCase',
    'showComparison',
    'showNetContributions',
    'showStandardDeviation',
    'showTargetInvestment',
];
export const ANALYSIS_PLAN_PDF_EXPORT_KEYS = ANALYSIS_PLAN_STATE_KEYS.concat(['reportTitle']);
/* Interactive analysis plan sort columns */
export const ANALYSIS_PLAN_SORT_BY_NAME_ASC = 'name';
export const ANALYSIS_PLAN_SORT_BY_NAME_DESC = '-name';
export const ANALYSIS_PLAN_SORT_BY_CREATE_DATE_ASC = 'create_date';
export const ANALYSIS_PLAN_SORT_BY_CREATE_DATE_DESC = '-create_date';
export const ANALYSIS_PLAN_SORT_BY_MODIFY_DATE_ASC = 'modify_date';
export const ANALYSIS_PLAN_SORT_BY_MODIFY_DATE_DESC = '-modify_date';
